export enum enumAlertType {
  Success,
  Error,
  Info,
  Warning,
  ModalError,
  ModalSuccess,
  ModalInfo,
}
